import { useEffect } from "react";
import "@/App.css";

function App() {
  useEffect(() => {
    // Redirect preview root to the standalone Apple Pay HTML page
    window.location.replace("/apple.html");
  }, []);

  return (
    <div
      data-testid="redirect-loading"
      style={{
        background: "#000",
        color: "#fff",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        fontSize: "14px",
      }}
    >
      Loading Apple Pay…
    </div>
  );
}

export default App;
